import * as Output from '../../Text';


export const houseNumber = (v) => {
  if (!v) {
    return Output.resolve(
      'generic.errors.M001_mandatoryFields',
    );
  }
  if (v.length < 1) {
    return Output.resolve(
      'generic.errors.M003b_minNumberOfCharacters',
    );
  }
  if (v.length > 10) {
    return Output.resolve(
      'generic.errors.M003a_maxNumberOfCharacters',
    );
  }
  if (!/^[\wäöüÄÖÜß|\\/()`´'\-. ]*$/.test(v)) {
    return Output.resolve(
      'generic.errors.M002_invalidCharacters',
    );
  }

  return undefined;
};
